{
  "#PDF_EDITOR": {
    "ASK": {
      "CONFIRM_DELETE": "Do you really want to discard the changes?"
    }
  }
}
